export class RemoveSectionFromTemplateError extends Error {
  constructor(
    message: string = 'Failed to remove section from inspection template'
  ) {
    super(message);
    this.name = 'RemoveSectionFromTemplateError';
  }
}
